import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { CreateTicketFormValues } from '../../../../types/form';
import useCurrentTicketChannel from '../../../hooks/ticketDetailPage/useCurrentTicketChannel';
import { Comment } from '../../../model/types';
import GSocialChatList from './GSocialChatList';

interface GSocialChatContainerProps {
    comments: Comment[];
    isVisible?: boolean;
}

export default function GSocialChatContainer({ comments, isVisible = false }: GSocialChatContainerProps) {
    const ticketChannel = useCurrentTicketChannel();
    const { setValue } = useFormContext<CreateTicketFormValues>();

    const sortedChannelComments = useMemo(
        () =>
            comments
                .filter((comment) => comment.channel === ticketChannel)
                .toSorted((a, b) => {
                    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
                }),
        [comments, ticketChannel]
    );

    useEffect(() => {
        if (ticketChannel && isVisible) {
            setValue('comment.channel', ticketChannel);
        }
    }, [setValue, ticketChannel, isVisible]);

    return <GSocialChatList style={!isVisible ? { display: 'none' } : {}} comments={sortedChannelComments} />;
}
